import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addCreditCardToInstacart = async (email: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddCreditCardToInstacart($email: String!) {
        addCreditCardToInstacart(email: $email)
      }
    `),
    variables: {
      email,
    },
  });

  return response.data?.addCreditCardToInstacart ?? false;
};
